import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c6d78da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "finding-versus flex flex-grow align-center" }
const _hoisted_2 = { class: "finding-value flex flex-grow align-center" }
const _hoisted_3 = { class: "score flex-grow" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))

import IbIcons from "@/components/icons/ib-icons.vue";
import { Insight } from '@/models/insight';
import { computed, PropType, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'Versus',
  props: {
  insight: {
    type: Object as PropType<Insight>,
    required: true,
  },
},
  emits: ["copyAIFindings"],
  setup(__props, { emit }) {

const props = __props;

const store = useStore()


const currentSlide = computed(() => store.state.currentSlide);

// const matan = ref(props.insight.value)

const hideLeftWidth = computed(() => {
  if (props.insight.value > 0.5) {
    return 50;
  }
  return parseInt((props.insight.value * 100).toFixed(0));
})

const hideRightWidth = computed(() => {
  if (props.insight.value < 0.5) {
    return 50;
  }
  return 100 - parseInt((props.insight.value * 100).toFixed(0));
})



const { t } = useI18n({
  inheritLocale: true,
  useScope: "local",
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(IbIcons, {
      icon: "ai",
      size: "14",
      class: "ai-icon"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["legend flex-shrink", {'main': props.insight.value < 0.5}])
      }, _toDisplayString(_unref(t)(`config.insight.slide.${_unref(currentSlide).tissueType}.${_unref(currentSlide).stain}.${__props.insight.key}.${__props.insight.legend[0]}`)), 3),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", {
          class: "hide-left",
          style: _normalizeStyle({'width': `${_unref(hideLeftWidth)}%`})
        }, null, 4),
        _createElementVNode("div", {
          class: "hide-right",
          style: _normalizeStyle({'width': `${_unref(hideRightWidth)}%`})
        }, null, 4)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["legend flex-shrink", {'main': props.insight.value > 0.5}])
      }, _toDisplayString(_unref(t)(`config.insight.slide.${_unref(currentSlide).tissueType}.${_unref(currentSlide).stain}.${__props.insight.key}.${__props.insight.legend[1]}`)), 3)
    ])
  ]))
}
}

})